module.exports = __webpack_public_path__ + "static/media/globe_black_big.b086a072.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/icons/globe_black_big.png
// module id = ./src/assets/media/icons/globe_black_big.png
// module chunks = 16